/**
 * WCAG 1.4.10 — Multimedia8 phone frame must fit without horizontal scroll.
 *
 * Figma EDS Phone sizes:
 * - Desktop / tablet (94:2680): 248 × 502
 * - Mobile (94:2681): 205 × 414
 */
export const PHONE_FRAME_WIDTH_PX = 248;
export const PHONE_FRAME_HEIGHT_PX = 503;

export const PHONE_MOBILE_FRAME_WIDTH_PX = 205;
export const PHONE_MOBILE_FRAME_HEIGHT_PX = 414;

/** Matches theme.breakpoints[0] — below this = mobile phone size. */
export const PHONE_MOBILE_MAX_WIDTH_PX = 599;

/**
 * Horizontal gutter for LayoutColumns `px: md` (16+16) — keep in sync with
 * theme space.md / LayoutColumns defaults.
 */
export const PHONE_VIEWPORT_GUTTER_PX = 32;

/** Uniform scale from desktop design coords → mobile Figma size. */
export const PHONE_MOBILE_DESIGN_SCALE =
  PHONE_MOBILE_FRAME_WIDTH_PX / PHONE_FRAME_WIDTH_PX;

export function isPhoneMobileViewport(
  viewportWidth = typeof window !== 'undefined' ? window.innerWidth : Infinity
): boolean {
  if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) return false;
  return viewportWidth <= PHONE_MOBILE_MAX_WIDTH_PX;
}

export function getPhoneFrameSize(
  viewportWidth = typeof window !== 'undefined' ? window.innerWidth : Infinity
): { width: number; height: number } {
  return isPhoneMobileViewport(viewportWidth)
    ? {
        width: PHONE_MOBILE_FRAME_WIDTH_PX,
        height: PHONE_MOBILE_FRAME_HEIGHT_PX
      }
    : { width: PHONE_FRAME_WIDTH_PX, height: PHONE_FRAME_HEIGHT_PX };
}

/**
 * Extra shrink so the *current* frame (desktop or mobile) fits the CSS viewport.
 */
export function getPhoneFitScale(
  viewportWidth = typeof window !== 'undefined' ? window.innerWidth : Infinity,
  frameWidth = getPhoneFrameSize(viewportWidth).width
): number {
  if (!Number.isFinite(viewportWidth) || viewportWidth <= 0) return 1;
  return Math.min(1, (viewportWidth - PHONE_VIEWPORT_GUTTER_PX) / frameWidth);
}
